import { useEffect } from 'react'
const GlobalRedirect = ({ pageContext: { toUrl } }) => {
  useEffect(() => {
    window.location.assign(toUrl)
  }, [toUrl])
  return (null)
}

export default GlobalRedirect
